<template>
  <div>
    <div v-if="key" class="flex items-center">
      <div class="now-dot mr-2 adjust" :class="key" />
      <div v-text="opts[key]" />
    </div>
  </div>
</template>

<script>
const day = 1000 * 60 * 60 * 24

/* eslint-disable no-extra-boolean-cast */

export default {
  name: 'BaseTimeText',
  props: {
    item: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      default: 'span'
    },
    mark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    key () {
      const now = new Date()

      if (this.start) {
        if (now >= this.start && now <= this.end) {
          if (now >= this.end - day) {
            return 'end'
          } else {
            return 'now'
          }
        } else if (now >= this.start - day && now <= this.end) {
          return 'soon'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    start () {
      const [s, t] = [new Date(this.item.start), new Date(this.item.start_time)]
      return !!t.valueOf() ? t : !!s.valueOf() ? s : false
    },
    end () {
      const [e, t] = [new Date(this.item.end), new Date(this.item.end_time)]
      return !!t.valueOf() ? t : !!e.valueOf() ? e : false
    },
    opts () {
      // TODO: This should connect to locales/translation maybe?
      const o = {
        en: {
          now: 'NOW',
          soon: 'SOON',
          end: 'ENDING SOON'
        },
        cn: {
          now: '进行中',
          soon: '即将发生',
          end: '即将结束'
        }
      }
      return o[this.$store.state.locale]
    }
  }
}
</script>
